import { CanMatchFn } from '@angular/router';

import { isGuaranteesV2Enabled } from '../providers/guarantees-v2.config';

/**
 * Keeps the route from matching at all while the feature is off, so it is never
 * reachable by typing the URL and its chunk is never requested.
 */
export const guaranteesV2EnabledGuard: CanMatchFn = () => isGuaranteesV2Enabled();
